var _path, _path2, _path3, _path4, _path5, _line;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWikiMenuFashionItem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 9.16667C15.8333 7.32572 17.3257 5.83333 19.1667 5.83333H20.8333C22.6743 5.83333 24.1667 7.32572 24.1667 9.16667V10H15.8333V9.16667Z",
    stroke: "#FF791C",
    strokeWidth: 1.66667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33337 17.5C8.33337 13.8181 11.3181 10.8333 15 10.8333H25C28.6819 10.8333 31.6667 13.8181 31.6667 17.5V31.6667C31.6667 33.5076 30.1743 35 28.3334 35H11.6667C9.82576 35 8.33337 33.5076 8.33337 31.6667V17.5Z",
    fill: "#C6C6C6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33337 15.8333C8.33337 12.1514 11.3181 9.16667 15 9.16667H25C28.6819 9.16667 31.6667 12.1514 31.6667 15.8333V30C31.6667 31.841 30.1743 33.3333 28.3334 33.3333H11.6667C9.82576 33.3333 8.33337 31.841 8.33337 30V15.8333Z",
    fill: "#D1CFCD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6667 20C33.0475 20 34.1667 21.1193 34.1667 22.5V27.5C34.1667 28.8807 33.0475 30 31.6667 30V20Z",
    fill: "#5C5B5A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33337 30C6.95266 30 5.83337 28.8807 5.83337 27.5L5.83337 22.5C5.83337 21.1193 6.95266 20 8.33337 20L8.33337 30Z",
    fill: "#5C5B5A"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 17.0834,
    y1: 25.4167,
    x2: 22.9167,
    y2: 25.4167,
    stroke: "#ECECEC",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWikiMenuFashionItem);
export default __webpack_public_path__ + "static/media/wikiMenuFashionItem.85b39217fa0b388fe51b5f3bc05f86a4.svg";
export { ForwardRef as ReactComponent };